// Module
var code = "<div>\n\n  <section class=\"heading\">\n    <div class=\"row no-gutter\">\n      <ng-include src=\"'/dashboard/nav.html'\"></ng-include>\n    </div>\n\n  </section>\n\n\n  <div class=\"row no-gutter\">\n    <div class=\"col-md-12 m m-t-lg\">\n      <ng-include src=\"'/shared/publicProfile.html.erb'\"></ng-include>\n    </div>\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/dashboard/profile.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;